interface SectionHeadingProps {
  badge?: string
  title: string
  subtitle?: string
  centered?: boolean
  light?: boolean
}

export default function SectionHeading({
  badge,
  title,
  subtitle,
  centered = true,
  light = false,
}: SectionHeadingProps) {
  return (
    <div
      className={`mb-12 md:mb-16 animate-page-in ${centered ? 'text-center max-w-2xl mx-auto' : ''}`}
    >
      {badge && (
        <span
          className={`inline-block font-heading font-semibold text-xs uppercase tracking-widest mb-4 px-4 py-1.5 rounded-full ${
            light
              ? 'bg-white/10 text-amber'
              : 'bg-sage text-forest'
          }`}
        >
          {badge}
        </span>
      )}
      <h2
        className={`font-heading font-bold text-3xl md:text-4xl lg:text-5xl text-balance leading-tight ${
          light ? 'text-white' : 'text-gray-900'
        }`}
      >
        {title}
      </h2>
      {subtitle && (
        <p
          className={`mt-4 text-lg md:text-xl leading-relaxed ${
            light ? 'text-white/70' : 'text-gray-600'
          }`}
        >
          {subtitle}
        </p>
      )}
    </div>
  )
}
